import { LOGIN } from "codes";
import history from "./history";

let logoutPromise: Promise<void> | undefined;
let logoutToken: string | null | undefined;
let logoutPending = false;

const getCurrentToken = (): string | null => {
  try {
    const token = localStorage.getItem("token");
    return token
      ? (JSON.parse(token) as { value?: string }).value ?? null
      : null;
  } catch {
    return null;
  }
};

export const unAuthorizedLogout = (
  unauthorizedToken: string | null = getCurrentToken(),
): Promise<void> => {
  const currentToken = getCurrentToken();
  const requestToken = unauthorizedToken;

  // A delayed 401 from a previous session must not clear a newer login.
  if (currentToken !== requestToken) {
    return Promise.resolve();
  }

  // Several in-flight requests can receive 401 together. Share the logout for
  // that session; after a new login, its different token permits a fresh logout.
  if (
    logoutPromise &&
    ((logoutPending && requestToken === logoutToken) || currentToken === null)
  ) {
    return logoutPromise;
  }

  logoutToken = requestToken;
  logoutPending = true;
  logoutPromise = (async () => {
    try {
      // Dynamic import avoids a store → API → axios → logout cycle at module load.
      const [{ store }, { clearAuthSession }] = await Promise.all([
        import("redux/store"),
        import("./enhancedClearStorage"),
      ]);
      // The user may sign in while these modules are loading.
      if (getCurrentToken() !== requestToken) {
        return;
      }
      clearAuthSession(store.dispatch);
      history.push(LOGIN);
    } catch (error) {
      const latestToken = getCurrentToken();
      if (latestToken !== null && latestToken !== requestToken) {
        return;
      }
      console.error("Error during unauthorized logout:", error);
      localStorage.removeItem("token");
      localStorage.removeItem("email");
      history.push(LOGIN);
    } finally {
      if (logoutToken === requestToken) {
        logoutPending = false;
        logoutToken = undefined;
        logoutPromise = undefined;
      }
    }
  })();

  return logoutPromise;
};
